const SpacerComponent = {
    templateUrl: '/formViewer/component/spacer/spacer.tpl.html',
    controller: 'spacerController',
    bindings: {
        fieldStructure: '<'
    }
};

angular.module('umFormViewer')
    .component('uiSpacer', SpacerComponent);
